// import { useActionCable } from '@aersoftware/react-use-action-cable';
import { createConsumer } from '@rails/actioncable';
export const useActionCableCreate = (chatUrl: string) => {
    const actionCable = createConsumer(chatUrl);
    return actionCable;
};
